<div [class.active]="(visible && position === ButtonPosition.GRID) || position === ButtonPosition.GRID_FULL">
  <div
    class="cta-host"
    [class.visible]="visible"
    [ngClass]="{
      grid:
        position === ButtonPosition.GRID ||
        position === ButtonPosition.GRID_FULL ||
        position === ButtonPosition.GRID_TWO_THIRDS_RIGHT,
      full: position === ButtonPosition.FULL
    }"
  >
    <div
      class="cta-container"
      [ngClass]="{
        'grid-col-12 grid-max-width':
          position === ButtonPosition.GRID ||
          position === ButtonPosition.GRID_FULL ||
          position === ButtonPosition.GRID_TWO_THIRDS_RIGHT
      }"
    >
      <div
        class="cta-button ps-medium-t ps-xsmall-b"
        [ngClass]="{
          'col-1-12':
            position === ButtonPosition.GRID ||
            position === ButtonPosition.GRID_FULL ||
            position === ButtonPosition.GRID_TWO_THIRDS_RIGHT,
          'sm-col-2-7 md-col-2-8': position === ButtonPosition.GRID,
          'md-col-5-12': position === ButtonPosition.GRID_TWO_THIRDS_RIGHT,
          'sm-col-3-10 xl-col-4-9': position === ButtonPosition.GRID_FULL,
          disabled: disabled
        }"
      >
        <div
          class="cta-flex white-text font-body-1 nordic-blue-900-bg flex flex--center rounded-medium shadow"
          [ngClass]="{ 'flex--column': layout === ButtonLayout.COLUMN }"
        >
          <div class="flex-1 flex--basis0 fill">
            <div class="ps-xxsmall-x ps-xxsmall-t fill align-center">
              <ng-content></ng-content>
            </div>
          </div>
          <div class="flex-1 flex--basis0 fill ps-xsmall">
            <fcom-button
              class="ps-xxsmall fill"
              [disabled]="disabled"
              [loading]="loading"
              [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
              [text]="title"
              [theme]="theme"
              [mode]="ButtonMode.FILL"
              [icon]="icon"
              (click)="buttonClicked.emit($event)"
            ></fcom-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
